// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3190ead6","977":"b5529a7c"}[chunkId] + ".chunk.js";
};